import { hasCapability, type User } from "../base";

export const projectCheckIn = {
  create: (user: User) => hasCapability(user, "projectCheckIn.create"),
  read: (user: User) => hasCapability(user, "projectCheckIn.read"),
  delete: (user: User) => hasCapability(user, "projectCheckIn.delete"),
};
